module.exports = __webpack_public_path__ + "static/avalon-84ee0e6942b02dd838ef521b6eaa72e9.svg";